<script setup lang="ts">
const { isMrbilit } = useWhiteLabel();
</script>

<template>
    <div>
        <slot />
        <VitePwaManifest v-if="isMrbilit" />
    </div>
</template>
